import React from "react";

const RVTabFiltersPreview = ({ config, classes }) => {
  return (
    <div style={{ display: "flex", justifyContent: "start", borderBottom: "1px solid #ccc" }} className={classes}>
      {config.placeholder?.map((tab, index) => (
        <div
          key={tab.id}
          style={{
            padding: "10px 20px",
            backgroundColor: "#f0f0f0",
            marginRight: "4px",
            borderBottom: index === 0 ? "3px solid #007bff" : "none"
          }}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default RVTabFiltersPreview;
